import jQuery from 'jquery';
import moment from 'moment';
import Swal from 'sweetalert2';
import validator from 'validator';
import authHelper, { getMtaApAuthData } from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { apiBaseUrl } from './helpers/config';
import { addDNoneClass, byId, Toast } from './helpers/utility';

 
// initializing jquery 
const $ = window.$ = window.jQuery = jQuery;
require('datatables.net')(window, $);

 
authHelper.validate();
hydrateApBasicData();




$('#data_table').DataTable({
    processing: true,
    serverSide: true,


    ajax: {
        url: `${apiBaseUrl}/users/getAllUsersDataTable`,
        type: 'GET',
        beforeSend: function (request) {
            request.setRequestHeader('Authorization', `Bearer ${getMtaApAuthData().accessToken}`);
        },
        error: function (jqXHR, exception) {
            console.log({jqXHR});
            console.log({exception});
            // Your error handling logic here..
        }
    },
    aaSorting: [],
    columns: [
        { data: 'userId' },
        { data: 'fullName' },
        { data: 'email' },
        { data: 'mobileNumber' },
        {
            data: 'depositCredit',
            render: function (data) {

                return `₹${data}`;
            }
        },
        {
            data: 'winCredit',
            render: function (data) {

                return `₹${data}`;
            }
        },
        {
            data: 'bonusCredit',
            render: function (data) {

                return `₹${data}`;
            }
        },
        {
            data: 'createdAt',
            render: function (data) {
                const createdAt = data;
                const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                const time = moment(createdAt * 1000).format('LT');
                return `${date} <br> ${time}`;
            }

        },
        {
            data: {
                userId: 'userId',
                fullName: 'fullName',
                depositCredit: 'depositCredit',
                winCredit: 'winCredit',
            },
            orderable: false,
            // eslint-disable-next-line no-unused-vars
            render: function (data, type, row, meta) {
                
                return `<button onclick="updateUserWalletFun.init(${JSON.stringify(data).split('"').join('&quot;')})"
                class="btn btn-success">Update Wallet</button>`;
            }
        },
        {
            data: {
                userId: 'userId'
            },
            orderable: false,
            // eslint-disable-next-line no-unused-vars
            render: function (data, type, row, meta) {
                
                return `<button onclick="updateUserPasswordFun.init(${JSON.stringify(data).split('"').join('&quot;')})"
                                                class="btn btn-primary">Change Password</button>`;
            }
        },
        {
            data: {
                userId: 'userId',
                fullName: 'fullName',
            },
            orderable: false,
            // eslint-disable-next-line no-unused-vars
            render: function (data, type, row, meta) {
                
                return `<button onclick="deleteUserFun.init(${JSON.stringify(data).split('"').join('&quot;')})"
                class="btn btn-danger" >Delete User</button>`;
            }
        }

    ]
});




const updateUserPasswordCardDivElement = byId('updateUserPasswordCardDivElement');
const updateUserPasswordUserIdInput = byId('updateUserPasswordUserIdInput');
const newPasswordInput = byId('newPasswordInput');
const confirmNewPasswordInput = byId('confirmNewPasswordInput');
const updateUserPasswordFun = {
    init: ({ userId }) => {
        addDNoneClass(updateUserPasswordCardDivElement, false);
        updateUserPasswordUserIdInput.value = userId;
        newPasswordInput.value = '';
        confirmNewPasswordInput.value = '';
    },
    cancel: () => {
        addDNoneClass(updateUserPasswordCardDivElement, true);
    },
    submit: async () => {
        try {
            // validation 
            if (!validator.isLength(newPasswordInput.value, { min: 8, max: 50 })) {

                Toast.fire({
                    icon: 'error',
                    title: 'Password length Must Between 8 to 50'
                });

                return false;
            }
            if (newPasswordInput.value !== confirmNewPasswordInput.value) {

                Toast.fire({
                    icon: 'error',
                    title: 'Password not matching'
                });

                return false;
            }

            const data = {
                userId: updateUserPasswordUserIdInput.value,
                password: newPasswordInput.value
            };
            const response = await callTheApServerPost('/users/updateUserPassword', { data: data });
            axiosResponseHandler(response);
            const res = response.data;
            console.log(res);

            if (res.status === 'success') {
                Swal.fire({
                    title: 'User Password Updated',
                    icon: 'success',
                    showConfirmButton: true,


                    allowOutsideClick: true,
                    timer: 3000

                });


            }



        } catch (error) {
            console.log(error);
            axiosErrorHandler(error);
        }
    }
};

const deleteUserFun = {
    init: ({ userId, fullName }) => {
        Swal.fire({
            title: 'Are you sure?',
            text: ` to Permanently  Delete Account of ${fullName}[${userId}]`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteUserFun.submit({ userId });
            }
        });
    },

    submit: async ({ userId }) => {
        try {



            const response = await callTheApServerGet(`/users/deleteUser/${userId}`);
            axiosResponseHandler(response);
            const res = response.data;
            console.log(res);

            if (res.status === 'success') {
                Swal.fire({
                    title: 'Deleted!',
                    icon: 'success',
                    text: `User has been deleted.`,
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });
                setTimeout(() => {
                    location.reload();
                }, 3000);


            }



        } catch (error) {
            console.log(error);
            axiosErrorHandler(error);
        }
    }
};

window.deleteUserFun = deleteUserFun;




window.updateUserPasswordFun = updateUserPasswordFun;

const updateUserWalletCardDivElement = byId('updateUserWalletCardDivElement');
const userIdInput = byId('userIdInput');
const fullNameInput = byId('fullNameInput');
const depositCreditInput = byId('depositCreditInput');
const winCreditInput = byId('winCreditInput');









const walletSelectInput = byId('walletSelectInput');
const actionSelectInput = byId('actionSelectInput');
const amountInput = byId('amountInput');
const commentInput = byId('commentInput');





const updateUserWalletFun = {
    init: ({ userId, fullName, depositCredit, winCredit }) => {

        addDNoneClass(updateUserWalletCardDivElement, false);
        userIdInput.value = userId;
        fullNameInput.value = fullName;
        depositCreditInput.value = depositCredit;
        winCreditInput.value = winCredit;


    },
    cancel: () => {

        addDNoneClass(updateUserWalletCardDivElement, true);

    },
    submit: async () => {


        try {
            // validation 
            if (amountInput.value < 1) {

                Toast.fire({
                    icon: 'error',
                    title: 'Amount Must be more than 1'
                });

                return false;
            }
            const userId = userIdInput.value;
            const data = {
                userId,
                walletSelect: walletSelectInput.value,
                actionSelect: actionSelectInput.value,
                amount: amountInput.value,
                comment: commentInput.value
            };
            const response = await callTheApServerPost('/users/updateUserWallet', { data: data });
            axiosResponseHandler(response);
            const res = response.data;
            console.log(res);

            if (res.status === 'success') {
                Swal.fire({
                    title: 'User Wallet Updated',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);
            }
        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }


    },

};
window.updateUserWalletFun = updateUserWalletFun;
